$(document).ready(function() {
    // Mobile Part ~ Menu
    if (window.matchMedia('(max-width: 768px)').matches) {
        $(".my-account-btn").appendTo("nav .menu-drawer__menu.list-menu");
    }

    // Login Modal
    $('.login-modal-btn').click(function() {
        $('body').addClass('fixScreen');
        $('.login-popup').addClass('show');
    });
    $('.closeLoginModal').click(function() {
        $('.login-popup').removeClass('show');
        $('body').removeClass('fixScreen');
        $('.login-box').show();
        $('.reset-box').hide();
    });

    // Reset Password
    $('.reset-box').hide();
    $('.login-box').show();
    $('.forgot-link').click(function() {
        $('.login-box').hide();
        $('.reset-box').show();
    });
    $('.back-to-login-btn').click(function() {
        $('.login-box').show();
        $('.reset-box').hide();
    });

    // Signup Modal
    $('.signup-modal-btn').click(function() {
        $('body').addClass('fixScreen');
        $('.signup-popup').addClass('show');
        $('.login-popup').removeClass('show');
    });
    $('.closeSignupModal').click(function() {
        $('.signup-popup').removeClass('show');
        $('body').removeClass('fixScreen');
    });

    // Form submission (Register)
    $('#customerRegisterForm').on('submit', function(e) {
        e.preventDefault(); // Prevent default form submission
        const $form = $(this); // Cache form
        const formData = $form.serialize(); // Serialize form data for AJAX
        $.ajax({
            type: 'POST',
            url: '/', // Shopify customer account endpoint
            data: formData,
            success: function(response) {
                // Handle success (e.g., show a success message)
                alert('Registration successful!');
                // Optionally, redirect after successful registration
                window.location.href = '/account/success';
            },
            error: function(error) {
                // Handle error (e.g., display error messages)
                console.error('Error:', error);
                alert('Registration failed. Please try again.');
            }
        });
    });

    // Customer Dropdown
    $('.customer-dropdown-btn').click(function() {
        $('.customer-privet-dropdown').toggleClass('active');
        $('.customer-dropdown-box').toggleClass('show');
    });
});

// Outside click Hide ~ (Customer Dropdown)
$(document).click(function(event) {
    if (!$(event.target).closest('.customer-dropdown-box, .customer-dropdown-btn').length) {
        $('.customer-dropdown-box').removeClass('show');
        $('.customer-privet-dropdown').removeClass('active');
    }
});